
import auth from '@/middleware/auth';
import {showPermission, showRole, createRole, updateRole} from "@/middleware/permissions/laratrust";

export default [
    {
        path: 'laratrust/permissions',
        name: 'permissions',
        meta: {
            layout: 'main',
            middleware: [auth, showPermission]
        },
        component: () => import('@/views/laratrust/permission/PermissionsView')
    },
    {
        path: 'laratrust/roles',
        name: 'roles',
        meta: {
            layout: 'main',
            middleware: [auth, showRole]
        },
        component: () => import('@/views/laratrust/role/RolesView')
    },
    {
        path: 'laratrust/roles/create',
        name: 'roles.create',
        meta: {
            layout: 'main',
            middleware: [auth, createRole]
        },
        component: () => import('@/views/laratrust/role/RoleCreateView')
    },
    {
        path: 'laratrust/roles/:id',
        name: 'roles.edit',
        meta: {
            layout: 'main',
            middleware: [auth, updateRole]
        },
        component: () => import('@/views/laratrust/role/RoleEditView')
    }
];